import { BUILDING_PREFIX } from 'shared/consts';

/**
 * Creates path patterns for React Router that work with both regular and building-prefixed routes
 * @param path - The base path pattern
 * @returns An array of path patterns [with building prefix, without building prefix]
 */
export const withBuildingPrefix = (path: string): string[] => {
  const buildingPath = `${BUILDING_PREFIX}${path}`;
  return [buildingPath, path];
};
